import { getCodeList } from "country-list";
import { tz } from "moment-timezone";

export function guessUserCountry() {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    for (const country of tz.countries()) {
        const timeZones = tz.zonesForCountry(country);
        if (timeZones.includes(userTimeZone)) {
            return country.toUpperCase();
        }
    }

    return "US";
}

export function getPostalCodeProps(countryCode: string): {
    show: boolean;
    placeholder: string;
    validate: (value: string) => boolean;
    normalize: (value: string) => string;
    name: string;
} {
    if (countryCode === "US") {
        return {
            show: true,
            placeholder: "00000",
            validate: value => /^\d{5}$/.test(value),
            normalize: value => value.replace(/\D/g, "").slice(0, 5),
            name: "Zip code"
        };
    }

    if (countryCode === "CA") {
        return {
            show: true,
            placeholder: "T5M 1A3",
            validate: value => /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i.test(value),
            normalize: value => value.replace(/[^A-Z0-9 -]/gi, ""),
            name: "Postal code"
        };
    }

    if (countryCode === "GB") {
        return {
            show: true,
            placeholder: "RG6 1FL",
            validate: value => /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/.test(value),
            normalize: value => value.replace(/[^A-Z0-9 -]/gi, ""),
            name: "Postal code"
        };
    }

    return {
        show: false,
        placeholder: undefined,
        validate: () => true,
        normalize: value => value,
        name: "Postal code"
    };
}

export function getAllCountryCodes() {
    return Object.entries(getCodeList())
        .map(([code, name]) => ({ code: code as string, name: name as string }))
        .sort((a, b) => a.name.localeCompare(b.name));
}
